.unsupportedContainer {
	padding: 0 0.375rem;
	gap: 1rem;
	display: flex;
	flex-direction: column;
}

.multiplePlatforms:global(.MuiTypography-root) {
	color: #000;
	font-weight: 400;
	font-size: 0.9375rem;
	line-height: 1.5;
}

.categoryContainer {
	display: flex;
	flex-direction: column;
	gap: 0.375rem;
}

.category:global(.MuiTypography-root) {
	font-size: 1.125rem;
	font-weight: 700;
	line-height: 1.4;
}

.optionRow {
	display: flex;
	padding: 0.25rem 0;
	gap: 1.25rem;
}

.optionTitleIconWrapper {
	display: flex;
	flex-basis: 35%;
	align-items: center;
	gap: 0.375rem;
	max-width: 200px;

	.optionName {
		font-weight: 700;
		color: #000;
		line-height: 1.5;
		font-size: 0.9375rem;
	}
}

.optionDescription:global(.MuiTypography-root) {
	flex-basis: 65%;
	vertical-align: middle;
	color: #000;
	font-weight: 400;
	font-size: 0.9375rem;
	line-height: 1.5;
}

@media (max-width: 768px) {
	.categoryContainer {
		align-items: center;
	}
	.optionRow {
		flex-direction: column;
		gap: 0.5rem;
	}

	.optionTitleIconWrapper {
		flex-direction: column;
		align-items: center;
		max-width: unset;
	}

	.optionDescription:global(.MuiTypography-root) {
		text-align: center;
	}
}
